import { getQuotes } from "@iewcasia/Services/CustomQuotesService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuotes";

replaceInChain(chain, RequestDataFromApi, async props => {
  props.apiResult = await getQuotes(props.apiParameter);
});
